/* eslint-disable */

import React, { FC } from 'react';
import withLocalization from '../hoc/withLocalization';
import './PackageCollapseDetails.scss';
import './PackageOverview.scss';
import { replacePlaceholder, removeDecimalPart } from '../../util/CommonLogic';
interface SearchPanelProps {
  localize?: any;
  localizeImages?: any;
  history: any;
  packageData: any;
}
const PackageOverviewSummary: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { packageData, localize } = props;
  const symbol = localize('preview-sales-engine.static-content.copy.pbeo.intl.usd-label');

  //const retVal = replacePlaceholder(packageData?.retailVal, '$', symbol);
  const getRetVal = packageData?.retailVal || '';
  const splitRetVal = getRetVal?.split('$') || '';
  const refineRetPrice = removeDecimalPart(splitRetVal[1]) || '';
  const retVal = `${symbol}${refineRetPrice}`;
  const totalDue = replacePlaceholder(packageData?.totalDue, '$', symbol);
  const dueToday = replacePlaceholder(packageData?.dueToday, '$', symbol);
  const dueAtBookAmt = replacePlaceholder(packageData?.dueAtBooking, '$', symbol);

  return (
    <>
      <div className="packageOverviewContentWrapper">
        {refineRetPrice && (
          <div className="packageCommonRow">
            <span className="packageHeaderContent">
              {localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-retail-value-label')}
            </span>
            <span className="packageDescContent-bold">
              <s>{`${retVal}`}</s>
            </span>
          </div>
        )}

        <div className="packageCommonRow">
          <span className="packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.total-due-label')}
          </span>
          <span className="packageDescContent-bold">{`${totalDue}`}</span>
        </div>
        <div className="packageCommonRow">
          <span className="packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.fees-and-taxes-label')}
          </span>

          <span className="packageDescContent-bold">
            {localize('preview-sales-engine.static-content.copy.pbeo.included-label')}
          </span>
        </div>
        <div className="packageOverviewDiveder"></div>
        <div className="packageCommonRow">
          <span className="new-packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-due-today-label')}
          </span>
          <span className="dueTodaycContent">{`${dueToday}`}</span>
        </div>
        <div className="packageOverviewDiveder"></div>
        {packageData?.dueAtBooking && (
          <div className="packageCommonRow">
            <span className="new-packagebalancerContent">
              {localize('preview-sales-engine.static-content.copy.pbeo.due-at-booking-label')}
            </span>
            <span className="packageDescContent-bold">{`${dueAtBookAmt}`}</span>
          </div>
        )}
      </div>
    </>
  );
};
export default withLocalization(PackageOverviewSummary);
